import * as Utils from './utils';
import { BackendObjectRef } from './backend-integration.service';

export class State implements BackendObjectRef {
    private static readonly ID_PREFIX = 'ws-';
    private static readonly INITIAL_STATE: State = new State(undefined, 'INITIAL', false);

    public readonly id: string;

    public static get initialState(): State {
        return State.INITIAL_STATE;
    }

    public get isInitialState(): boolean {
        return this.id === State.INITIAL_STATE.id;
    }

    public readonly name: string;

    private _draft: boolean;
    public get isDraft(): boolean { return this._draft === true; }
    public set isDraft(draft: boolean) { this._draft = draft; }

    public canDeleteRoles: BackendObjectRef[];

    constructor(id: string|undefined, name: string, draft?: boolean, canDeleteRoles: BackendObjectRef[] = []) {
        this._draft = draft ?? (id ? false : true);
        this.id = id ?? `${State.ID_PREFIX}${Utils.randomString()}`;
        this.name = name.toLocaleUpperCase();
        this.canDeleteRoles = canDeleteRoles;
    }
}
